export enum DisplayScale {
  default = 'default',
  thousands = 'thousands',
  millions = 'millions',
  auto = 'auto'
}

export const SCALE_SUFFIX_CONFIG: Record<DisplayScale, { suffix: string; divisor: number }> = {
  [DisplayScale.default]: { suffix: '', divisor: 1 },
  [DisplayScale.thousands]: { suffix: 'k', divisor: 1_000 },
  [DisplayScale.millions]: { suffix: 'M', divisor: 1_000_000 },
  [DisplayScale.auto]: { suffix: '', divisor: 1 }
}

export interface NumberFormatConfig {
  displayScale?: DisplayScale
  decimals?: number
  showScaleSuffix?: boolean
  showUnit?: boolean
}

export const resolveAutoScale = (value: number): DisplayScale => {
  const abs = Math.abs(value)
  if (abs >= 1_000_000) return DisplayScale.millions
  if (abs >= 1_000) return DisplayScale.thousands
  return DisplayScale.default
}

export const getScaleDivisor = (displayScale?: DisplayScale): number => {
  return displayScale ? SCALE_SUFFIX_CONFIG[displayScale].divisor : 1
}

export const getScaleSuffix = (displayScale?: DisplayScale): string => {
  return displayScale ? SCALE_SUFFIX_CONFIG[displayScale].suffix : ''
}
